import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  /** Defaults to the pricing card. Only the pricing card links to checkout. */
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Willow gold is the single action colour on this page, against the outfield
 * greens. Grass green marks what's included; cherry red is kept for tension.
 */
export function CtaButton({
  children,
  href = '#offer',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-lg sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex w-full items-center justify-center gap-2 bg-willow text-center font-display font-extrabold tracking-tight text-willow-ink shadow-card transition-[background-color,box-shadow] duration-150 ease-out hover:bg-willow-hover hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-cream/70 ${sizing} ${className}`} data-id="element-118" data-mp="35xxt0rx2krtt">
      {children}
    </a>;
}